import React from 'react'
import styled from 'styled-components'
import { Grid as BaseGrid } from '@material-ui/core'
import { Close as BaseCloseIcon, Info as BaseInfoIcon, Search as BaseSearchIcon } from '@material-ui/icons'
import { Spinner } from '@chilecompra/react-kit/components'

export const Root = styled.div`
  box-sizing: border-box;
  padding: 0 0 130px;
  width: 100%;
`

export const Section = styled(({ margin, maxWidth, ...props }) => <BaseGrid {...props} />)`
  max-width: ${props => props.maxWidth || 'initial'};

  &.MuiGrid-item {
    margin: ${props => props.margin || 'initial'};
  }
`

export const Strong = styled.span`
  font-weight: bold;
`

export const Title = styled.h1`
  color: ${props => props.theme.palette.custom.mineShaft};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 34px;
  font-weight: 300;
  letter-spacing: 0;
  margin: 0;

  ${props => props.theme.breakpoints.only('xs')} {
    text-align: center;
  }
`

export const Instructions = styled.p`
  color: ${props => props.theme.palette.custom.charcoal};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 22px;
  font-weight: 300;
  letter-spacing: 0;
  line-height: 1.3;
  margin: 0;

  ${props => props.theme.breakpoints.only('xs')} {
    text-align: center;
  }
`

export const Form = styled.form`
  width: 100%;
`

export const LinkHelp = styled('a')`
  align-items: center;
  color: ${props => props.theme.palette.blue[50]};
  cursor: pointer;
  font-weight: 400;
  font-size: 14px;
  text-decoration: none;
  pointer-events: visible;

  &:hover {
    color: ${props => props.theme.palette.blue[35]};
    text-decoration: underline;
  }
`

export const Search = styled(({ clear, loading, ...props }) => <button {...props} />)`
  align-items: center;
  background-color: ${props => (props.clear ? props.theme.palette.brand.black3 : props.theme.palette.brand.primary)};
  border: 0;
  border-radius: 0;
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  display: flex;
  height: 100%;
  justify-content: center;
  opacity: ${props => (props.disabled ? 0.5 : 1)};
  outline: 0;
  pointer-events: ${props => (props.disabled ? 'none' : 'initial')};
  user-select: ${props => (props.disabled ? 'none' : 'initial')};
  width: 40px;

  &:focus {
    outline: 0;
  }

  &:hover {
    background-color: ${props => (props.clear ? props.theme.palette.gray[35] : props.theme.palette.blue[35])};
  }
`

export const SearchClearIcon = styled(BaseCloseIcon)`
  color: ${props => props.theme.palette.brand.white};
  height: 24px;
  width: 24px;
`

export const SearchIcon = styled(BaseSearchIcon)`
  color: ${props => props.theme.palette.brand.white};
  height: 24px;
  width: 24px;
`

export const SearchLoadingIcon = styled(props => <Spinner {...props} size="18px" />)`
  color: ${props => props.theme.palette.brand.white};
  & .MuiCircularProgress-root {
    color: ${props => props.theme.palette.brand.white};
  }
`

export const TaxesKeyInstructions = styled.p`
  color: ${props => props.theme.palette.custom.charcoal};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 16px;
  font-weight: 300;
  letter-spacing: 0;
  margin: 0;
`

export const TaxesKey = styled.div`
  margin: 100px 0 0 184px;

  ${props => props.theme.breakpoints.only('xs')} {
    margin: 60px 0 0;
  }
`

export const TaxesKeyButton = styled.img`
  border: 0;
  cursor: pointer;
  display: block;
  width: 200px;

  ${props => props.theme.breakpoints.only('xs')} {
    margin: 0 auto;
  }
`

export const TaxesKeyHelp = styled.div`
  margin: 16px 0 0;
  text-align: center;
  width: 200px;

  ${props => props.theme.breakpoints.only('xs')} {
    margin: 16px auto 0;
  }
`

export const TaxesKeyHelpIcon = styled(BaseInfoIcon)`
  color: ${props => props.theme.palette.brand.primary};
  height: 0.38em;
  width: 0.38em;
`

export const TaxesKeyHelpLink = styled.a`
  color: ${props => props.theme.palette.brand.primary};
  cursor: pointer;
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 13px;
  letter-spacing: 0;
`

export const ActivitiesLink = styled.a`
  color: ${props => props.theme.palette.brand.primary};
  cursor: pointer;
  font-weight: medium;
  letter-spacing: 0;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`

export const SpinnerContainer = styled.div`
  align-items: center;
  background-color: rgb(255, 255, 255);
  display: flex;
  height: 100%;
  justify-content: center;
  min-height: 100px;
  width: 80%;
`
